import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppValidators } from 'src/app/common/appValidators';
import { FilterTypesEnum } from 'src/app/models/filters/filterTypes.enum';
import { AuditLogEventsFiltersModel } from 'src/app/models/filters/implementations/pageFilters/AuditLogEventsFilters.model';

@Component({
  selector: 'app-audit-log-events-filters',
  templateUrl: './audit-log-events-filters.component.html',
  styleUrls: ['./audit-log-events-filters.component.scss'],
})
export class AuditLogEventsFiltersComponent implements OnInit {
  @Input() public pageFilters: AuditLogEventsFiltersModel;

  public searchBoxNewValue = new BehaviorSubject<string | undefined>(undefined);
  public fromDateNewValue = new BehaviorSubject<Date | undefined>(undefined);
  public toDateNewValue = new BehaviorSubject<Date | undefined>(undefined);
  public searchValidators = [AppValidators.evenNumberOfQuoteMarks];

  ngOnInit(): void {
    this.pageFilters.onUpdate$.subscribe((data) => {
      this.searchBoxNewValue.next(data.search);
      this.fromDateNewValue.next(data.fromDate);
      this.toDateNewValue.next(data.toDate);
    });
  }

  public fromDateSelected(value?: Date): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.FromDate, value);
  }

  public toDateSelected(value?: Date): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.ToDate, value);
  }

  public searchSubmitted(value?: string): void {
    this.pageFilters.updateFilterFromUserSelection(FilterTypesEnum.Search, value);
  }
}
